export default __webpack_public_path__ + "static/media/drag.cc4dd858.svg";